import React from 'react'
import { SvgIcon } from '../svg-icon'

/**
 * Define default props as fallback. See SvgIcon base class for propTypes.
 *
 * @static
 * @type {React.defaultProps}
 */
const defaultProps = {
    viewBoxSize: 48
}

/**
 * Stateless function representing a dashboard trend icon.
 *
 * @function
 * @param {Object} [props] The component properties
 * @returns {ReactElement} React component markup
 *
 * @see SvgIcon
 * @example
 * <DashboardIcon width={12} />
 */
const DashboardTrendIcon = props => (
    <SvgIcon {...props}>
        <path
            d={`M40.21,13.82V34.14a2.65,2.65,0,0,1-2.78,2.74,2.76,2.76,0,0,1-2.8-2.74V23.47s0-.08,
            0-0.13V13.83l-5.78,1.93L37.41,2,46,15.76ZM39.93,46a2.76,2.76,0,0,0,2.76-2.78,2.66,2.66,
            0,0,0-2.76-2.76H4.76A2.76,2.76,0,0,0,2,43.24,2.66,2.66,0,0,0,4.76,46H39.93ZM30.1,21.56a2.76,
            2.76,0,0,0-2.8-2.74,2.65,2.65,0,0,0-2.78,2.74V34.14a2.75,2.75,0,0,0,2.8,2.74,2.65,2.65,0,0,
            0,2.78-2.74V21.56ZM9.89,25.28a2.76,2.76,0,0,0-2.8-2.74,2.65,2.65,0,0,0-2.78,2.74v8.86a2.75,
            2.75,0,0,0,2.8,2.74,2.65,2.65,0,0,0,2.78-2.74V25.28Zm10.11,2a2.76,2.76,0,0,0-2.8-2.74,2.65,
            2.65,0,0,0-2.78,2.74v6.89a2.75,2.75,0,0,0,2.8,2.74A2.65,2.65,0,0,0,20,34.14V27.25Z`}
        />
    </SvgIcon>
)

DashboardTrendIcon.defaultProps = defaultProps

export { DashboardTrendIcon }
